module.exports = __webpack_public_path__ + "media/images/preview/preview_laptop-7d28dc3642eef1d84320f8230e3dc467.png";